<style lang="less">
/*@import "./Check.less";*/
</style>
<template>
  <div class="container-fluid">
    <!--头部-->
    <div class="row header jss-transparent">
      <div class="col-lg-12 text-center">
        <span>自助检票系统{{versionNo}}</span>
      </div>
    </div>
    <!--交互内容显示区-->
    <div class="row content">
      <!-- <div class="col-lg-12 text-center" style="font-size: 50px;">
        <span>欢迎使用自助验票系统</span>
      </div> -->
      <div class="col-lg-12 text-center" style="font-weight:500" :style="{'margin-top':logoHeight+'px','font-size':fontSize+'px'}">
        <div id="message">{{message}}</div>
        <div>{{checkTime}}</div>
      </div>
    </div>

    <!--尾部-->
    <div class="row footer jss-transparent navbar navbar-default navbar-fixed-bottom">
      <div class="col-lg-12">
        本机序列号：
        <span>{{devSn}}</span>
        <span>{{gateInfo.store_name}} {{versionNo}}</span>
      </div>
    </div>
  </div>
</template>

<script>
require("!style-loader!css-loader!less-loader!./Check.less");

import { loadAudioSrc, getSignReqData } from "../../assets/js/jssFunction";
import * as deviceOperate from "../../assets/js/deviceOperate";
import { setCallBackFun } from "../../assets/js/devcieCallback";
import { DEVICE_CODE } from "../../assets/js/config";

export default {
  data() {
    return {
      message: "正在进行系统初始化。。。",
      checkTime: "",
      devSn: "",
      versionNo: "V3006",
      gateInfo: { store_name: "未获取" },
      checkFlag: true,
	  debugFlag: false, //工厂测试模式
	  logoHeight:600,
	  fontSize:44,
    };
  },

	mounted: function() {
		// alert(window.screen.availHeight);
		if(window.screen.availHeight<=500){
			this.fontSize = 39;
		}else{
			this.fontSize = 44;
		}
		this.logoHeight = (window.screen.availHeight*1-340)/2;
		global.LOCAL_DATA.devInfo.checkFlag = false;
		try {
			this.init();
		} catch (e) {
			this.message = "系统初始化失败";
		}
	},

  methods: {
	  
    init: function() {
		deviceOperate.openDevice(DEVICE_CODE.DT_CODE, "", "", "");
		deviceOperate.getDev().BRStartRead(DEVICE_CODE.DT_CODE, 0);
		deviceOperate.writeAppLog( 4,"二维码设备打开状态：" +deviceOperate.getDev().BRStartRead(DEVICE_CODE.DT_CODE, 0));
		deviceOperate.openDevice(DEVICE_CODE.DT_MODBUS, "", "", "");
		try {
			let result = deviceOperate.openDevice(DEVICE_CODE.DT_ID, "", "", "");
			deviceOperate.writeAppLog(
			4,
			"打开身份证阅读器结果:" +
				result +
				",设备信息:" +
				deviceOperate.getLastMsg()
			);
			result = deviceOperate.getDev().IDStartRead(DEVICE_CODE.DT_ID, 0);
			if (result != 0) {
			deviceOperate.writeAppLog(4, "身份证阅读器启用失败");
			}
		} catch (e) {}

    	setCallBackFun(this.callBack);
      //todo 序列号验证，终端信息初始化
		global.LOCAL_DATA.devInfo.devSn = deviceOperate.getDev().GetHDSN();
                    //  global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";
		this.netInit();
    },

    netInit: function() {
		this.devSn = global.LOCAL_DATA.devInfo.devSn;
		let reqData = getSignReqData();
		let that = this;
		let url = "";
		if (reqData.sign == "") {
			url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
		} else {
			url =
			this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
		}
		this.$http.post( url,JSON.stringify(reqData),this.GlobalConfig.APP_CONFIG.HEADERS)
			.then(function(response) {
			if (response.data.status == "success") {
				that.message = "请将票券上的二维码放在扫码器前扫码验票";
				global.LOCAL_DATA.systemInfo = response.data.systemInfo;
				that.gateInfo = response.data.gateInfo;
				that.debugFlag = false;
				loadAudioSrc("系统初始化成功，请将票券上的二维码放在扫码器前扫码验票");
			} else {
				that.message = response.data.msg;
				global.LOCAL_DATA.systemInfo = response.data.systemInfo;
				that.debugFlag = true;
				setTimeout(function() {
					that.netInit();
				}, 15000);
			}
        })
        .catch(function(error) {
			that.message = "网络异常，正在重新获取配置信息";
			that.debugFlag = true;
			if (that && !that._isDestroyed) {
				setTimeout(function() {
					if (that && !that._isDestroyed) that.netInit();
				}, 15000);
			}
        });
    },

    callBack: function(DeviceID, UserEvtID, RetCode, RetMsg) {
		switch (DeviceID) {
			//二维码阅读器
			case DEVICE_CODE.DT_CODE:
				this.onCodeEvent(UserEvtID, RetCode, RetMsg);
			break;
			case DEVICE_CODE.DT_ID:
				this.onIdEvent(UserEvtID, RetCode, RetMsg);
			break;
		}
    },

    test: function() {
		this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
      //                this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
    },

    //二维码验票
    onCodeEvent: function(UserEvtID, RetCode, RetMsg) {
		if (global.LOCAL_DATA.devInfo.checkFlag) return;
		global.LOCAL_DATA.devInfo.checkFlag = true;
		loadAudioSrc("正在验票");
		if (RetMsg.indexOf("employee") >= 0) {
			this.message = "员工验码";
			this.employeeCheck(RetMsg);
		} else {
			this.message = "正在验票";
			this.check(RetMsg);
		}
    },

    //身份证验票
    onIdEvent: function(UserEvtID, RetCode, RetMsg) {
		if (global.LOCAL_DATA.devInfo.checkFlag) return;
		global.LOCAL_DATA.devInfo.checkFlag = true;
		let idInfo = deviceOperate.getDev().IDReadData(DEVICE_CODE.DT_ID, 5);
		this.message = "正在身份证验票";
		loadAudioSrc("正在身份证验票");
		let idCardInfo = "TL_003_" + idInfo.split("|")[5];
		this.check(idCardInfo);
    },

    msgRestore: function() {
		let that = this;
		setTimeout(function() {
			deviceOperate.getDev().IDStartRead(DEVICE_CODE.DT_ID, 0);
			that.message = "请将票券上的二维码放在扫码器前扫码验票";
		}, 5000);
    },

    employeeCheck: function(qrCode) {
		if (!this.checkFlag) return;
		this.checkFlag = false;
		let that = this;
		let reqData = getSignReqData();
		reqData.gate_uid = this.gateInfo.gate_uid;
		reqData.gate_type = this.gateInfo.gate_type;
		reqData.enterprise_uid = this.gateInfo.enterprise_uid;
		reqData.qr_code = qrCode;
		let url = "";
		if (reqData.sign == "") {
			url =
			this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
		} else {
			url =
			this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
		}
		this.$http.post(url,JSON.stringify(reqData),this.GlobalConfig.APP_CONFIG.HEADERS)
        .then(function(response) {
			if (response.data.status == "success") {
				that.message = response.data.msg;
				loadAudioSrc(that.message);
				//开闸
				deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 1000);
				that.msgRestore();
			} else {
				that.message = response.data.msg;
				loadAudioSrc(that.message);
				that.msgRestore();
			}

			setTimeout(function() {
				that.checkFlag = true;
				global.LOCAL_DATA.devInfo.checkFlag = false;
			}, 500);
        })
        .catch(function(error) {
			global.LOCAL_DATA.devInfo.checkFlag = false;
			that.message = "网络异常，验票失败,请重试";
			that.checkFlag = true;
			loadAudioSrc(that.message);
			that.msgRestore();
        });
    },

    //扫码验票
    check: function(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;

      if (qrCode == "TL20180808752033987" && this.debugFlag) {
        this.message = "请注意，测试验票成功，请入闸";
        loadAudioSrc(this.message);
        //开闸
        deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 1000);
        this.checkFlag = true;
        global.LOCAL_DATA.devInfo.checkFlag = false;
        this.msgRestore();
        return;
      }
      let that = this;
      let reqData = getSignReqData();
      reqData.gate_uid = this.gateInfo.gate_uid;
      reqData.gate_type = this.gateInfo.gate_type;
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.store_uid = this.gateInfo.store_uid;
      reqData.qr_code = qrCode;
      let url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
      } else {
        url =
          this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
      }
      this.$http
        .post(
          url,
          JSON.stringify(reqData),
          this.GlobalConfig.APP_CONFIG.HEADERS
        )
        .then(function(response) {
          if (response.data.status == "success") {
            that.message = response.data.msg;
             //开闸
            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 1000);
            loadAudioSrc(that.message);
						 that.msgRestore();
						 setTimeout(function() {
            that.checkFlag = true;
            global.LOCAL_DATA.devInfo.checkFlag = false;
          }, 3000);
          } else {
            that.message = response.data.msg;
            loadAudioSrc(that.message);
						that.msgRestore();
						 setTimeout(function() {
            that.checkFlag = true;
            global.LOCAL_DATA.devInfo.checkFlag = false;
          }, 500);
          }
         
        })
        .catch(function(error) {
          global.LOCAL_DATA.devInfo.checkFlag = false;
          that.message = "网络异常，验票失败,请重试";
          that.checkFlag = true;
          loadAudioSrc(that.message);
          that.msgRestore();
        });
    }
  }
};
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/views/gateCheck/Check.vue